import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenubarComponent } from './menubar/menubar.component';

import { FooterComponent } from './footer/footer.component';
import {RouterLink, RouterOutlet} from "@angular/router";
import {MaterialModule} from "../material/material.module";
import { HeaderBannerComponent } from './header-banner/header-banner.component';
import { AnonymousLayoutComponent } from './anonymous-layout/anonymous-layout.component';
import { AnonymouHeaderComponent } from './anonymou-header/anonymou-header.component';
import { ToasterContainerComponent } from './toaster/toaster-container.component';
import { ToasterComponent } from './toaster/toaster.component';



@NgModule({
  declarations: [
    MenubarComponent,
    HeaderBannerComponent,
    FooterComponent,
    AnonymousLayoutComponent,
    AnonymouHeaderComponent,
  ],
  exports: [
    HeaderBannerComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterOutlet,
    RouterLink
  ]
})
export class SharedModule { }